<template>
  <div class="main">
    <Header :show="show" @listenEvent="fn" @listenHeight="getHeight" />
    <div
      class="imgshowbox"
      @click="changeShow"
      :style="'margin-top:' + msgboxTop + 'px'"
    >
      <div class="container">
        <img class="titleimg" src="../assets/images/topImg/9.jpg" alt="" />
        <div class="title-box">
          <div class="title-box-bottom">
            <h3 class="big-title">AI智能网络模组主板</h3>
            <p class="title-details">
              我司产品已全面进入智能监控时代，前端摄像机模组（IVG）配套后端录像机主板（NBD），实现人形检测、人脸抓拍、人脸查录像等智能功能；搭配手机客户端APP：xmeye
              pro，实现设备集中管理、配置、视频预览、录像回放、报警信息管理等功能，更有全球云服务，实现云存录像存储，报警短视频推送；完善的软硬件配合，为您搭建智能移动监控解决方案。
            </p>
            <!-- <van-button
              v-show="showVideo"
              round
              class="title-box-bottom-video"
              @click="
                () => {
                  this.$router.push({
                    name: 'video',
                    query: {
                      src:
                        'static/video/AIintelligentautonomouspackagesolution.mp4'
                    }
                  });
                }
              "
            >
              <van-icon :name="require('../assets/images/play.png')" />
              <span>AI智能自主套包解决方案</span>
            </van-button> -->
          </div>
        </div>
      </div>
      <div>
        <van-tabs v-model="active" swipeable animated>
          <van-tab
            v-for="item in messageList"
            :key="item.id"
            :title="item.title"
          >
            <div class="product-box">
              <div class="product-box-top">
                <p class="product-title">
                  {{ item.details }}
                </p>

                <div class="product-button">
                  <span v-for="list in item.buttonList" :key="list.id">
                    <router-link
                      :to="{ path: list.url, query: { src: list.src } }"
                    >
                      <van-button
                        class="title-box-bottom-video change-color"
                        round
                        ><van-icon :name="list.icon"></van-icon>
                        <span class="button-in-box">{{ list.text }}</span>
                      </van-button>
                    </router-link>
                  </span>
                </div>
              </div>

              <div
                class="product-box-middle"
                v-for="article in item.articleList"
                :key="article.id"
              >
                <div class="img-box">
                  <van-image width="100%" fit="contain" :src="article.src" />

                  <div>
                    <h4>{{ article.articletitle }}</h4>
                    <span class="product-details"
                      >{{ article.articledetails }}
                    </span>
                    <div v-for="list in article.traitList" :key="list.id">
                      <h5>{{ list.lightTitle }}</h5>
                      <p v-for="(light, index) in list.lightList" :key="index">
                        {{ light.light }}
                      </p>
                    </div>
                  </div>
                  <p class="linkmore" v-show="article.have">
                    <a :href="article.href">了解更多>>></a>
                  </p>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
export default {
  components: { Header },
  data() {
    return {
      src: "/video",
      show: false,
      active: 0,
      showVideo: true,
      msgboxTop: 0,

      messageList: [
        {
          id: 1,
          title: "NVR主板",
          details: "",
          buttonList: [
            // {
            //   id: 1 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 1 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 1 - 1 - 1,
              src: require("../assets/images/newAdd/13.jpg"),
              articletitle: "AI智能高清网络POE NVR主板",
              articledetails: "",
              traitList: [
                {
                  id: 1 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "8/16口POE IPC接入"
                    },
                    {
                      light: "支持单盘/双硬盘存储"
                    },
                    {
                      light: "支持人脸检测，人形检测，人脸录像回放"
                    },
                    {
                      light: "支持云存储"
                    },
                    {
                      light: "支持手机短视频报警推送"
                    }
                  ]
                }
                // {
                //   id: 1 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href: "https://www.xiongmaitech.com/product/product-list/4"
            },
            {
              id: 1 - 1 - 2,
              src: require("../assets/images/newAdd/16.jpg"),
              articletitle: "AI智能高清网络NVR主板",
              articledetails: "",
              traitList: [
                {
                  id: 1 - 1 - 1 - 2,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "10/16/32路高清4K接入"
                    },
                    {
                      light: "支持单盘/双盘/四盘位存储"
                    },
                    {
                      light: "支持人脸检测，人形检测，人脸录像回放"
                    },
                    {
                      light: "支持云存储"
                    },
                    {
                      light: "支持手机短视频报警推送"
                    }
                  ]
                }
                // {
                //   id: 1 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href: "https://www.xiongmaitech.com/product/product-list/4"
            }
          ]
        },
        {
          id: 6,
          title: "IPC模组",
          details: "",
          buttonList: [
            // {
            //   id: 1 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 1 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 6 - 1 - 1,
              src: require("../assets/images/newAdd/19.jpg"),
              articletitle: "300万AI智能IPC模组",
              articledetails: "",
              traitList: [
                {
                  id: 6 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "3MP（2304*1296）高清像素"
                    },
                    {
                      light: "尺寸：38*38"
                    },
                    {
                      light: "支持人形检测、人脸检测等智能功能"
                    },
                    {
                      light: "支持音频输入输出"
                    },
                    {
                      light: "支持手机报警推送"
                    }
                  ]
                }
                // {
                //   id: 6 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于餐厅，面包店，服饰店，便利店，宠物店，家庭住宅等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href: "https://www.xiongmaitech.com/product/product-list/198"
            },
            {
              id: 6 - 1 - 2,
              src: require("../assets/images/newAdd/22.jpg"),
              articletitle: "400万AI智能IPC模组",
              articledetails: "",
              traitList: [
                {
                  id: 6 - 1 - 1 - 2,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "4MP（2560*1440）高清像素"
                    },
                    {
                      light: "尺寸：38*38"
                    },
                    {
                      light: "支持人形检测、人脸检测等智能功能"
                    },
                    {
                      light: "支持音频输入输出"
                    },
                    {
                      light: "支持手机报警推送"
                    }
                  ]
                }
                // {
                //   id: 6 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于餐厅，面包店，服饰店，便利店，宠物店，家庭住宅等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href: "https://www.xiongmaitech.com/product/product-list/198"
            },
            {
              id: 6 - 1 - 3,
              src: require("../assets/images/newAdd/25.jpg"),
              articletitle: "500万AI智能IPC模组",
              articledetails: "",
              traitList: [
                {
                  id: 6 - 1 - 1 - 3,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "5MP（2592*1944）高清像素"
                    },
                    {
                      light: "尺寸：38*38"
                    },
                    {
                      light: "支持人形检测、人脸检测等智能功能"
                    },
                    {
                      light: "支持音频输入输出"
                    },
                    {
                      light: "支持手机报警推送"
                    },
                    {
                      light: "支持接入蜂云"
                    }
                  ]
                }
                // {
                //   id: 6 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于餐厅，面包店，服饰店，便利店，宠物店，家庭住宅等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href: "https://www.xiongmaitech.com/product/product-list/198"
            },
            {
              id: 6 - 1 - 4,
              src: require("../assets/images/newAdd/29.jpg"),
              articletitle: "800万AI智能IPC模组",
              articledetails: "",
              traitList: [
                {
                  id: 6 - 1 - 1 - 4,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "8MP（3840*2160）高清像素"
                    },
                    {
                      light: "尺寸：38*38"
                    },
                    {
                      light: "支持人形检测、人脸检测等智能功能"
                    },
                    {
                      light: "支持音频输入输出"
                    },
                    {
                      light: "支持手机报警推送"
                    },
                    {
                      light: "支持接入蜂云"
                    }
                  ]
                }
                // {
                //   id: 6 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于餐厅，面包店，服饰店，便利店，宠物店，家庭住宅等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href: "https://www.xiongmaitech.com/product/product-list/198"
            }
          ]
        }
      ]
    };
  },
  methods: {
    changeShow() {
      this.show = false;
    },
    fn(val) {
      this.show = val;
    },
    getHeight(val) {
      this.msgboxTop = val;
    }
  },
  watch: {
    msgboxTop(val) {
      this.msgboxTop = val;
    }
  }
};
</script>

<style></style>
